var $ce7c5117552d1b85$exports = {};
window.addEventListener("DOMContentLoaded", ()=>{
    const storage = window.localStorage;
    if (storage.getItem("accept-cookies") === "yes") document.querySelector("#cookiebanner").style.display = "none";
    else {
        const button = document.querySelector("#cookiebanner button");
        button.addEventListener("click", ()=>{
            document.querySelector("#cookiebanner").style.display = "none";
            if (storage.getItem("accept-cookies") !== "yes") storage.setItem("accept-cookies", "yes");
        });
    }
});


//# sourceMappingURL=index.2a0f7ec1.js.map
